import { promoteObjectSchema } from '@takeshape/json-schema/utils';
import latestProjectSchema from './latest.json';
export function getAgentSchema() {
    return promoteObjectSchema(latestProjectSchema, '#/definitions/agent');
}
export function getGuardSchema() {
    return promoteObjectSchema(latestProjectSchema, '#/definitions/guard');
}
export function getToolSchema() {
    return promoteObjectSchema(latestProjectSchema, '#/definitions/tool');
}
export function getNamedToolSchema() {
    const baseToolSchema = promoteObjectSchema(latestProjectSchema, '#/definitions/tool');
    return {
        ...baseToolSchema,
        properties: {
            ...baseToolSchema.properties,
            name: {
                type: 'string',
                title: 'Name'
            }
        },
        required: [...(baseToolSchema.required ?? []), 'name']
    };
}
